import React from 'react';
import { BarsOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import { useNavigate } from "react-router-dom"
import dataList from '../util';
import usePermissionVersion from '../hooks/usePermission';
import { can, canAny } from '../util/permission';

function buildItems() {
  const items = [
    {
      key: 'sub1',
      label: '首页',
      icon: <BarsOutlined />,
    },
    {
      key: 'sub2',
      label: '权限管理',
      icon: <BarsOutlined />,
      children: [
        {
          key: 'qx1',
          label: '角色管理',

        },
        {
          key: 'qx2',
          label: '管理员列表',
        },
      ],

    },
    {
      key: 'sub3',
      label: '系统管理',
      icon: <SettingOutlined />,
      children: [
        {
          key: 'xt1',
          label: '类目管理',
        },
        {
          key: 'xt2',
          label: '轮播图管理',
        },
        {
          key: 'xt3',
          label: '帮助文档管理',

        },
        {
          key: 'xt4',
          label: '关于我们编辑',

        },
        {
          key: 'xt5',
          label: '公告管理',

        },
        {
          key: 'xt6',
          label: '更改密码',

        },
      ],
    },
    {
      key: 'sub5',
      label: '任务管理',
      icon: <MailOutlined />,
      children: [
        {
          key: 'rw1',
          label: '任务列表',
        },
        {
          key: 'taskAppeal',
          label: '任务申诉处理',
        },
      ],
    },
    {
      key: 'sub6',
      label: '积分管理',
      icon: <MailOutlined />,
      children: [
        {
          key: 'pointsExpand',
          label: '推广积分管理',
        },
        {
          key: 'pointsMember',
          label: '会员积分管理',
        },
        {
          key: 'pointsUser',
          label: '用户积分详情',
        },
      ],
    },
  ];

  if (canAny('finance:')) {
    const financeChildren = [
      { key: 'cw1', label: '收入与扣税台账', perm: 'finance:income:list' },
      { key: 'cw2', label: '提现与资金流水', perm: 'finance:withdraw:list' },
      { key: 'cw3', label: '增值税代办台账', perm: 'finance:vat:list' },
      { key: 'cw4', label: '授权存证管理', perm: 'finance:auth:list' },
      { key: 'cw5', label: '平台订单明细', perm: 'finance:order:list' },
    ]
      .filter((item) => can(item.perm))
      .map(({ perm, ...item }) => item);

    if (financeChildren.length > 0) {
      items.push({
        key: 'sub7',
        label: '财务管理',
        icon: <MailOutlined />,
        children: financeChildren,
      });
    }
  }

  return items;
}

const Menu1 = () => {
  usePermissionVersion();
  const navigate = useNavigate()
  function goLogin(e) {
    // 代码跳转路由
    navigate(e, { replace: false })
  }
  const onClick = (e) => {
    dataList.forEach(element => {
      if (e.key === element.name) {
        const path = element.path
        goLogin(path)
        return
      }
    });
  };
  return (
    <Menu
      onClick={onClick}
      className="Menu1"
      defaultSelectedKeys={['1']}
      defaultOpenKeys={['sub1']}
      mode="inline"
      items={buildItems()}
    />
  );
}



export default Menu1;
